export default __webpack_public_path__ + "images/48ae08afbee0bd222f389add27721b97.svg";